import React, { useState, useEffect, useContext } from 'react';
import Pagination from '@mui/material/Pagination';
import { GlobalContext } from 'store/context/GlobalContext';

export default function Vote() {
    const [ paginationParams, setPaginationParams ] = useState({count: 0, activePage: 1, itemsCountPerPage: 6});
    const context = useContext(GlobalContext);
    const { userData } = context;
    const [ data, setData ] = useState([]);

    useEffect(() => {
        if(userData.vote_list.length > 0) {
            setPaginationParams({...paginationParams, count: userData.vote_list.length});
            setData(userData.vote_list.slice(0, paginationParams.itemsCountPerPage));
        }
    }, [userData])

    const handlePageChange = (event,idx) => {
        setPaginationParams({...paginationParams, activePage: idx});
        let newArray = userData.vote_list.slice((idx-1)*paginationParams.itemsCountPerPage, idx*paginationParams.itemsCountPerPage);
        setData(newArray);
    }

    return (<>
        <div className="fw-bold mgt-3 pdx-6 text-left m-auto lh-lg" style={{maxWidth: "760px"}}>※十六茶、「可爾必思」兩品牌採五戰三勝制對決，2022/09/13活動結束公布對決成果時，押注在最終獲勝方任一回合之所有點數皆享有抽獎資格，由系統自動判定，參賽者毋需額外操作申請。</div>
        {
            data.length > 0 ? (<>
                <div className="table-responsive">
                    <table className="record-table">
                        <thead>
                            <tr>
                                <th style={{width: "50%"}}>
                                    <div>投票日期</div>
                                </th>
                                <th style={{width: "50%"}}>
                                    <div>投票紀錄</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item, index) => 
                                    <tr key={index}>
                                        <td>{item.vote_date}</td>
                                        <td>{item.vote_item}</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    paginationParams.count > 6 &&
                    <div className="mgt-6 text-center">
                        <Pagination count={Math.ceil(paginationParams.count/paginationParams.itemsCountPerPage)} page={paginationParams.activePage} siblingCount={0} defaultPage={1} size="small" onChange={handlePageChange}/>
                    </div>
                }
            </>) : (
                <div className="non-data">尚無投票紀錄</div>
            )
        }
    </>)
}